import { RefObject } from 'react';
import HarmonyResultPDF from '../../../../../PageResultat/ResultatHarmony/ResultatPDF';
import MeaningResultPDF from '../../../../../PageResultat/ResultatMeanning/ResultatPDF';
import PreferenceResultPDF from '../../../../../PageResultat/ResultatPreference/ResultatPDF';
import PreferenceJeuneResultPDF from '../../../../../PageResultat/ResultatPreference/ResultatPDFJeune';
import StudyResultPDF from '../../../../../PageResultat/ResultatStudy/ResultatPDF';
import { MajorTestKind } from '../types';
import NeedsResultPdf from './NeedsResultPdf';

type MajorTestResultPdfProps = {
  kind: MajorTestKind;
  myResult: any;
  resultId: number;
  pdfRef: RefObject<any>;
};

const MajorTestResultPdf = ({ kind, myResult, resultId, pdfRef }: MajorTestResultPdfProps) => {
  if (!myResult) {
    return null;
  }

  switch (kind) {
    case 'meaning':
      return <MeaningResultPDF ref={pdfRef} myResult={myResult} idResult={resultId} />;
    case 'needs':
    case 'needsPro':
      return <NeedsResultPdf kind={kind} pdfRef={pdfRef} myResult={myResult} resultId={resultId} />;
    case 'preference':
      return <PreferenceResultPDF ref={pdfRef} myResult={myResult} />;
    case 'preferenceJeune':
      return <PreferenceJeuneResultPDF ref={pdfRef} myResult={myResult} idResult={resultId} />;
    case 'harmony':
      return <HarmonyResultPDF ref={pdfRef} myResult={myResult} idResult={resultId} />;
    case 'study':
      return <StudyResultPDF ref={pdfRef} myResult={myResult} idResult={resultId} />;
    default:
      return null;
  }
};

export default MajorTestResultPdf;
